// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"54b0fdcf","211":"f5ba8167"}[chunkId] + ".chunk.js";
};